import React from "react";
import {
    Box,
    Typography,
    Container,
    Button,
    Stack,
    Paper,
    Avatar,
} from "@mui/material";
import { Homeimages, scanner } from "../../assets";
import StarIcon from "@mui/icons-material/Star";

const TestimonialsQR = () => {
    return (
        <Box sx={{ backgroundColor: "#f2f2f2", py: 5, px:{xs:"auto",md:'50px'} }}>
            <Container >

                <Box
                    sx={{
                        backgroundColor: "#2e5471",
                        borderRadius: "16px",
                        py: 6,
                        px: 4,
                        textAlign: "center",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                    }}
                >
                    {/* TITLE */}
                    {/* SECTION TITLE */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mb: 4,
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontFamily: "'Playfair Display', serif !important",
                                fontSize: {xs:"20px",md:"50px"},
                                fontWeight: 600,
                                color: "#fff",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Testimonials
                        </Typography>

                        <Box
                            sx={{
                                flex: 1,
                                height: "1px",
                                background:
                                    "linear-gradient(to right, #ecedee, transparent)",
                            }}
                        />
                    </Box>


                    {/* SUBTITLE */}
                    <Paper
                        elevation={0}
                        sx={{
                            backgroundColor: "#eef2f5",
                            borderRadius: "14px",
                            p: 5,
                            borderLeft: "6px solid #0f63a5",
                            textAlign: "start"
                        }}
                    >
                        {/* STARS */}
                        <Box sx={{ mb: 2 }}>
                            {[...Array(5)].map((_, index) => (
                                <StarIcon
                                    key={index}
                                    sx={{
                                        color: "#0f63a5",
                                        fontSize: 20,
                                        mr: 0.5,
                                        textAlign: "start"
                                    }}
                                />
                            ))}
                        </Box>

                        {/* TESTIMONIAL TEXT */}
                        <Typography
                            sx={{
                                fontSize: "16px",
                                lineHeight: 1.8,
                                color: "#333",
                                fontStyle: "italic",
                                mb: 4,
                                maxWidth: "900px",
                                    fontFamily: "'Lato', sans-serif !important",
                            }}
                        >
                           I have known Rajiv for several years and have always been impressed by his deep knowledge and strategic approach to sales and business development. He is a true entrepreneur and advisor, with a keen eye for identifying market opportunities and a talent for building successful sales frameworks. His insights are invaluable, and he consistently demonstrates a forward-thinking perspective. Rajiv is a go-to resource for anyone seeking expert advice and mentorship in the competitive world of sales and
consulting.
                        </Typography>

                        {/* CLIENT INFO */}
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar
                                src={Homeimages.user}  // put image in public folder
                                alt="Satisfied Client"
                                sx={{
                                    width: 45,
                                    height: 45,
                                    border: "2px solid #0f63a5",
                                    boxShadow: "0 4px 10px rgba(15,99,165,0.2)",
                                }}
                            />

                            <Box>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        color: "#1b1b1b",
                                        textAlign: 'start',
                                        fontFamily: "'Playfair Display', serif !important",
                                    }}
                                >
                                    Mahesh Valsa
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        color: "#6b6b6b",
                                        textAlign: 'start',
                                            fontFamily: "'Lato', sans-serif !important",
                                    }}
                                >
                                   
Driving Growth & Innovation | Key Account Expert in Banking, FinTech, & Digital Transformation
                                </Typography>
                            </Box>
                        </Stack>
                    </Paper>

                    {/* QR IMAGE */}
                    {/* <Box
            component="img"
            src={scanner}   // Put your QR image in public folder
            alt="Scan for LinkedIn Recommendation"
            sx={{
              width: "220px",
              borderRadius: "20px",
              backgroundColor: "#ffffff",
              p: 2,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          /> */}
                    <Button
                        variant="contained"
                        href="https://www.linkedin.com/in/rajivwilliams/details/recommendations/"  // 🔹 Put your LinkedIn recommendation link here
                        target="_blank"
                        sx={{
                            backgroundColor: "#1e63a6",
                            px: 4,
                            py: 1.5,
                            borderRadius: "8px",
                            fontWeight: 600,
                            textTransform: "none",
                            fontSize: "15px",
                            boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                            "&:hover": {
                                backgroundColor: "#174d83",
                            },
                            mt: 4
                        }}
                    >
                        View More Testimonials
                    </Button>

                    {/* OPTIONAL CAPTION UNDER QR */}

                </Box>
            </Container>
        </Box>
    );
};

export default TestimonialsQR;